import { get } from './http'
export default function getWorldDetail(id) {
  return get(`/api/singlepage/pubbenefit_detail?id=${id}`)
}
